import { Dialog } from '@mui/material';

import { AssignAssetTableContainer } from './assign-asset-table-container.component';

type AssignAssetModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (assetId: string) => void;
  selectedAssetId?: string | null;
};

export const AssignAssetModal = ({
  open,
  onClose,
  onConfirm,
  selectedAssetId,
}: AssignAssetModalProps) => {
  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <AssignAssetTableContainer
        onClose={onClose}
        onConfirm={onConfirm}
        initialSelectedAssetId={selectedAssetId}
      />
    </Dialog>
  );
};
